import { jsx as _jsx } from "react/jsx-runtime";
import halfRoseUrl from '../../../assets/gems/half_rose.svg?inline';
export function HalfRose({ ...props }) {
    return _jsx("img", { ...props, src: halfRoseUrl, alt: 'HalfRoseImage' });
}
